(function (angular, saveAs) {
    'use strict';

    /**********************************************************************
     * Service that opens the report-generate-modal dialog.
     *********************************************************************/
    angular.module('bmrcReportGenerateModalService', ['bmpDownload', 'bmrcReportGenerateService', 'bmrcReportGenerateComponent',
    'bmpBatchProcessFactory', 'bmpBatchProcessDialog', 'pascalprecht.translate'])
        .service('bmrcReportGenerateModalService', ['$uibModal', '$timeout', function ($uibModal, $timeout) {

        this.showDialog = function (selectedItems, repository) {
            var modalInstanceCtrl = ['$scope', '$q', '$uibModalInstance','$http', '$translate', 'bmpDownload', 'bmrcReportGenerateService',
            'bmpBatchProcessFactory', 'bmpBatchProcessDialog', 'bmpErrorHandler',
            function ($scope, $q, $uibModalInstance, $http, $translate, bmpDownload, bmrcReportGenerateService, batchProcessFactory, batchProcessDialog, bmpErrorHandler) {
                $scope.model = selectedItems;
                var acceptFunc = function (options) {

                    var downloadCount = 0;

                    var getFileNameFromHeaders = function (response) {
                        var contentDisposition = response.headers('Content-Disposition');
                        if(contentDisposition) {
                            var fileNameMatches = /filename=["]?([^";]*)/g.exec(contentDisposition);

                            if(fileNameMatches && fileNameMatches.length > 1) {
                                return fileNameMatches[1];
                            }
                        }

                        return null;
                    };

                    var syncProcessFunc = function(item) {
                        var downloadProcess = options.downloadToComputer ?
                        repository.getSecuredReportDownloadUrl(item).then(function (url) { // TODO - ng161 - handle reject
                                var completeUrl = url + '&reportDefinitionId=' + item.id + '&reportOutputTypeId=' + options.fileTypeToGenerate;
                                if(url.indexOf('simple-auth:') !== -1) {
                                    // The simple-auth method uses the FileSaver component (https://github.com/eligrey/FileSaver.js)
                                    return $http({ url: completeUrl.replace('simple-auth:', ''), method: 'GET', responseType: 'arraybuffer', params: {}, headers: {} }).then(function(result) {
                                        // TODO - ng161 - handle reject
                                        // set type based on options.fileTypeToGenerate
                                        var file = new Blob([result.data], { type: result.headers.contentType });
                                        var fileName = getFileNameFromHeaders(result) || 'Report' + downloadCount.toString() + '.' + options.fileTypeToGenerate;

                                        saveAs(file, fileName);
                                    });
                                } else {
                                    bmpDownload.download('Report' + downloadCount.toString(), completeUrl);
                                }
                                downloadCount += 1;
                            }) :
                            $q.when(undefined);

                        var sendToDocumentsProcess = options.sendToOnvio ?
                        repository.getSendReportToOnvioDocumentsUrl(item).then(function (url) { // TODO - ng161 - handle reject
                            var body = {
                                    'reportDefinitionId': item.id,
                                    'reportOutputTypeId': options.fileTypeToGenerate,
                                    'documentFolderId': options.documentFolderId
                                };

                                return $http({ url: url, method: 'POST', data: body, headers: {} }); // TODO - ng161 - handle reject
                            }) :
                            $q.when(undefined);

                        var sendToBinderDocumentsProcess = options.sendToBinderDocuments ?
                        repository.getSendReportToBinderDocumentsUrl(item).then(function (url) {
                            var body = {
                                reportDefinitionId: item.id,
                                reportOutputTypeId: options.fileTypeToGenerate,
                                isPreview: false,
                                token: '00000000000000000000000000000000' // Any token will work since is passed only because backend schema required.
                            };

                            return $http({ url: url, method: 'POST', data: body, headers: {} }); // TODO - ng161 - handle reject
                        }) :
                        $q.when(undefined);

                        return $q.all([downloadProcess, sendToDocumentsProcess, sendToBinderDocumentsProcess]).then(function() {
                            return true;
                        });
                    };

                    var asyncProcessFunc = function (item) {
                        if (!options.downloadToComputer && !options.sendToOnvio) {
                            return $q.when(undefined);
                        }
                        var body = {
                            reportDefinitionId: item.id,
                            reportOutputTypeId: options.fileTypeToGenerate,
                            sendToDms: options.sendToOnvio,
                            isDownload: options.downloadToComputer
                        };
                        var createDocumentRequestPromise = repository.postCreateDocumentRequest(body, true);
                        var createDocumentSecondApiRequestPromise = repository.getCreateDocumentApipromise();
                        var socketServicePromise = repository.getSocketServicePromise();
                        return $q.when(createDocumentRequestPromise).then(function (response) {
                            if(response === null) {
                                return false;
                            }
                            return $q.when(createDocumentSecondApiRequestPromise).then(function (response) {
                                if (response.hasOwnProperty('postRequestBody') && response.hasOwnProperty('jobId')) {
                                    response.postRequestBody.jobId = response.jobId;
                                    var messagePublishPromise = repository.postCreateDocumentRequest(response.postRequestBody, false);
                                    return $q.when(messagePublishPromise).then(function (response) {
                                        if (response === null) {
                                            repository.closeSocketConnection();
                                        }
                                        return $q.when(socketServicePromise).then(function (socketServiceResponse) {
                                            if(socketServiceResponse && socketServiceResponse.hasOwnProperty('jobId')) {
                                                var body = {
                                                    jobId: socketServiceResponse.jobId
                                                };

                                                var downloadProcess = socketServiceResponse.download ? repository.getSecuredReportDownloadUrlAsync(item, body).then(function (result) {
                                                    // set type based on options.fileTypeToGenerate
                                                    var file = new Blob([result.data], { type: result.headers.contentType });
                                                    var fileName = getFileNameFromHeaders(result) || 'Report' + downloadCount.toString() + '.' + options.fileTypeToGenerate;
                                                    saveAs(file, fileName);
                                                }) : $q.when(undefined);

                                                var documentPathPromise = socketServiceResponse.sendToDms ? repository.getSendReportToOnvioDocumentsUrlAsync(item, body):
                                                                            $q.when(undefined);
                                                return $q.all([downloadProcess, documentPathPromise]).then(function () {
                                                    return true;
                                                });
                                            } else {
                                                bmpErrorHandler.processErrors(null, $translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError'));
                                                return false;
                                            }
                                        });
                                    }, function () {
                                        repository.getProcessCreateDocumentRequestToSocketSrv(response.jobId, false);
                                        return false;
                                    });
                                } else {
                                    return false;
                                }
                            });
                        });
                    };

                    var useAsyncMode = repository.getUseNewAsyncMode();

                    var batchProcess = batchProcessFactory.createBatchProcess({
                        items: selectedItems,
                        processFunc: useAsyncMode ? asyncProcessFunc : syncProcessFunc
                    });

                    batchProcessDialog.open({// TODO - ng161 - handle reject
                        titleText: $translate.instant('Bluemoon.Reporting.Actions.Create'),
                        cancelText: $translate.instant('Bluemoon.Practice.Common.Buttons.Cancel'),
                        batchProcess: batchProcess
                    }).finally(function() {
                        $uibModalInstance.close('accept');
                        if (useAsyncMode) {
                            repository.closeSocketConnection();
                        }
                    });
                };

                bmrcReportGenerateService.setAcceptFunc(acceptFunc);

                var dismissFunc = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                bmrcReportGenerateService.setCancelFunc(dismissFunc);

                bmrcReportGenerateService.setDefinition(repository.createReportComponentDefinition);

                bmrcReportGenerateService.setGetSelectedFolder(repository.getGetSelectedFolder);

                $scope.close = function () {
                    $uibModalInstance.dismiss('close');
                };

                // Set focus on the close button after the dialog is opened
                $timeout(function() {
                    document.getElementById('closeButton').focus();
                }, 0);
            }];

            $uibModal.open({
                templateUrl: 'src/reporting/generate/report-generate-modal.html',
                controller: modalInstanceCtrl,
                windowClass: null,
                resolve: {
                    items: function () {
                        return null;
                    }
                },
            });
        };
    }]);
})(window.angular, window.saveAs);
